import React from "react";
import { Route, Switch } from "react-router-dom";
import Vehicles from "./Vehicles";
import Equipment from "./Equipment";

export default () => (
  <Switch>
    <Route path="/assets/vehicles" component={Vehicles} />
    <Route path="/assets/equipment" component={Equipment} />
  </Switch>
);
